import { InlineIcon } from "@iconify/react";
import _ from "lodash";
import PropTypes from "prop-types";
import React, { useContext } from "react";
import { createUseStyles } from "react-jss";
import { clipboardCopier } from "../../../helpers";
import jssVariables from "../../../jss_setup";
import { StyleTypeContext } from "../../../umbilical_tools";

const shareBtnStyles = createUseStyles({
  shareBtnContainer: (props) => ({
    position: "absolute",
    display: "grid",
    justifyContent: "center",
    alignContent: "center",
    top: props.placeBtmRight ? "unset" : jssVariables.normal_gap,
    left: props.placeBtmRight ? "unset" : `calc(${jssVariables.normal_gap} *1)`,
    bottom: props.placeBtmRight ? jssVariables.normal_gap : "unset",
    right: props.placeBtmRight ? jssVariables.normal_gap : "unset",
    height: `calc(${jssVariables.normal_gap} * 3)`,
    width: `calc(${jssVariables.normal_gap} * 3)`,
    borderRadius: "50%",
    background: "rgba(0,0,0, .2)",
    zIndex: 1079,
    color: "white",
    cursor: "pointer",
    ..._.get(props, "customStyles.shareBtnContainer", {}),
  }),
  icon: (props) => ({
    fontSize: "x-large",
    ..._.get(props, "customStyles.icon", {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {
    shareBtnContainer: (props) => ({
      ..._.get(props, "customStyles.shareBtnContainer.smallscreen", {}),
    }),
  },
});
export const ShareBtn = ({ path, placeBtmRight, hasFullPath }) => {
  const { type, brand, cStyler } = useContext(StyleTypeContext);

  const classes = shareBtnStyles({
    placeBtmRight,
    customStyles: cStyler({
      type,
      brand,
      objName: "shareBtn",
    }),
  });

  function copyLink() {
    clipboardCopier(hasFullPath ? path : window.location.origin + path);
  }

  return (
    <div className={classes.shareBtnContainer}>
      <InlineIcon
        icon="ci:share-outline"
        className={classes.icon}
        onClick={copyLink}
      />
    </div>
  );
};
ShareBtn.defaultProps = {
  placeBtmRight: false,
  hasFullPath: false,
};
ShareBtn.propTypes = {
  path: PropTypes.string.isRequired,
  placeBtmRight: PropTypes.bool,
  hasFullPath: PropTypes.bool,
};
